var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-show xy-start"},[_vm._t("start"),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._t("end")],2)}
var staticRenderFns = []

export { render, staticRenderFns }